module.exports = __webpack_public_path__ + "media/images/credits_panama_logo-f094349d682cab1069b7b880cb6f4aed9b53c45fe7a1ad6c29c0542d9d8cf094.jpg";